import { render } from "./PWalletWithdrawal.vue?vue&type=template&id=70b7dab6&scoped=true"
import script from "./PWalletWithdrawal.vue?vue&type=script&lang=js"
export * from "./PWalletWithdrawal.vue?vue&type=script&lang=js"

import "./PWalletWithdrawal.vue?vue&type=style&index=0&id=70b7dab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b7dab6"]])

export default __exports__